export const DragParagraph = {
  align: 'center',
  textAlign: 'center',
  margin: '- auto',
  color: 'placeholder',
  maxWidth: 'F1',
  flow: 'y',
  Lottie: {
    src: 'swipe-right.json',
    fontSize: 'B1',
    margin: '- - -X2',
  },
  Text: {
    text: 'Drag and drop these components to your canvas',
  },
};